import { render, staticRenderFns } from "./DPV.vue?vue&type=template&id=ccb7ad12&scoped=true"
import script from "./DPV.vue?vue&type=script&lang=js"
export * from "./DPV.vue?vue&type=script&lang=js"
import style0 from "./DPV.vue?vue&type=style&index=0&id=ccb7ad12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb7ad12",
  null
  
)

export default component.exports